__turbopack_context__.v({
  "reportThisEventButton": "ReportThisEventButton-module-scss-module__B7EPJa__reportThisEventButton",
  "reportThisEventButtonText": "ReportThisEventButton-module-scss-module__B7EPJa__reportThisEventButtonText",
});
